export default [
    {
        path: '',
        component: require('@/layouts/auth').default,
        meta: {
            auth: false
        },
        children: [
            {
                path: '/login',
                name: 'auth.login',
                component: require('@/views/auth/login').default,
                meta: {
                    auth: false
                }
            },
            /*
            {
                path: '/register',
                name: 'auth.register',
                component: require('@/screens/auth/register').default,
                meta: {
                    auth: false
                }
            },
            */
        ]
    }
];